import { useContext } from 'react';
import LocaleContext from './LocaleContext';
import LocaleProvider from './LocaleProvider';

export const useLocaleContext = () => useContext(LocaleContext);
export default LocaleProvider;
